import GetShopArticlePriceRequestModel from '../../../generated/types/model/request/GetShopArticlePriceRequestModel';

export default class GetShopArticlePriceRequestViewModel extends GetShopArticlePriceRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
